import { render, staticRenderFns } from "./ArchiveTables.vue?vue&type=template&id=6b5dcc47&"
import script from "./ArchiveTables.vue?vue&type=script&lang=js&"
export * from "./ArchiveTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports